import { FC, ReactNode } from 'react'
import { SideoverState } from '@/states'
import { CubeIcon } from '@heroicons/react/16/solid'

const Captured: FC = (): ReactNode => {
    const { Form } = SideoverState()

    if (Form?.Clipboard) return (
        <div className='flex flex-col items-center justify-center pt-5 pb-6 text-center px-8'>
            <div className='flex items-center mt-3 px-1.5 py-1  text-[#CDD5DA] bg-[#2E2E2E] border border-[#424242] rounded-md'>
                <CubeIcon className='flex-shrink-0 w-7 h-7 text-[#EBEBEB]' />

                <p className='ml-1 text-sm font-extrabold text-[#EBEBEB]'>
                    Component Captured
                </p>
            </div>

            <p className='text-xs text-[#9a9d9e] mt-4'>
                To remove it press <span className='px-1.5 py-1 text-xs font-semibold text-[#EBEBEB] bg-[#424242] border border-[#424242] rounded-md'>⌘</span> and <span className='px-1.5 py-1 text-xs font-semibold text-[#EBEBEB] bg-[#424242] border border-[#424242] rounded-md'>X</span> keystrokes.
            </p>
        </div>
    )
}

export default Captured
